"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY MODULES ***************************************/
var env_var_helpers_1 = require("env-var-helpers");
var javelin_exports_1 = require("../javelin-exports");
var javelin_impl_1 = require("../javelin-impl");
/******************************************** LOGGING *********************************************/
var shared_1 = require("mad-logs/lib/shared");
var log = shared_1.logFactory('sync-utils.ts', shared_1.Styles.rockIsDead);
var keys = Object.keys;
var accessTokenKey = "accessToken=";
/********************************************* EXPORT *********************************************/
/**
 * Build headers for POST or GET request ([reqType]) in javelin-sync, with
 * string array containing [cookies]
 */
exports.buildHeaders = function (reqType, cookies) {
    var requestTypeHeaders = { Accept: "application/json", 'Content-Type': "application/json" };
    var baseHeaders = reqType === "POST" || reqType === "PUT" ? requestTypeHeaders : {};
    var additionalHeaders = {};
    if (cookies && (Array.isArray(cookies) && cookies.length > 0)) {
        var tokenCookie = cookies.find(function (cookie) { return cookie.includes(accessTokenKey); });
        if (tokenCookie) {
            additionalHeaders = { Authorization: "Bearer " + tokenCookie.split(accessTokenKey)[1] };
        }
    }
    return __assign({}, baseHeaders, additionalHeaders);
};
/**
 * Extend request [body] object to include version, buildType, platform
 * @return {string} Stringified form of expanded request body object
 */
exports.buildBodyObj = function (body) {
    if (typeof body !== "string")
        return null;
    var bodyObj = JSON.parse(body);
    if (!bodyObj || keys(bodyObj).length === 0)
        return null;
    return __assign({}, bodyObj, { platform: "web", buildType: env_var_helpers_1.releaseEnv, version: (bodyObj.appVersion && bodyObj.appVersion.split("-")[0]) ||
            javelin_exports_1.JavelinManager.Companion.VERSION ||
            javelin_impl_1.JavelinImpl.version ||
            "UNKNOWN VERSION" });
};
/**
 * Make request of type [requestType] (POST OR GET) to sync server, with given [urlConfigs]
 * containing sync-server routes, [endpoint] key for grabbing from urlConfigs,
 * optional [cookies] array, optional request [body], & optional query [params]
 *
 * @param {ApiServerURLs} urlConfig Environment-aware collection mapping endpoints to actual URLs
 * @param {string} endpoint Endpoint to request to; used to extract receiving URL from urlConfig
 * @param {string[]} cookies List of cookies to include in request; May contain access token {OPT}
 * @param {string} body Request payload
 * @param {Object} params Query parameters to be appended to the request
 * @return {Promise<Response>} Response data
 */
exports.syncFetch = function (reqType, urlConfigs, endpoint, cookies, body, queryParams) {
    if (queryParams === void 0) { queryParams = {}; }
    var url = (urlConfigs[endpoint] && urlConfigs[endpoint].url) || endpoint;
    // prettier-ignore
    log.verbose("syncFetch ::", "url:", url, "cookies:", cookies, "body:", body, "queryParams:", queryParams);
    var bodyObj = exports.buildBodyObj(body);
    queryParams.platform = "web";
    queryParams.buildType = env_var_helpers_1.releaseEnv;
    queryParams.version = queryParams.version || bodyObj.version || "0.0.1";
    var enc = encodeURIComponent;
    var queryParamsStr = keys(queryParams)
        .map(function (key) { return enc(key) + "=" + enc(queryParams[key]); })
        .join("&");
    // Example final URL:
    // https://sync.qa.canimmunize.ca/api/v2/logout?platform=web&version=0.8.15.145-development&buildType=dev
    url = queryParamsStr ? url + "?" + queryParamsStr : url;
    return fetch(url, __assign({ method: reqType, mode: "cors", headers: exports.buildHeaders(reqType, [cookies]), credentials: "include" }, (bodyObj && { body: JSON.stringify(bodyObj) })));
};
//# sourceMappingURL=sync-utils.js.map